<script setup lang="ts">
import { useEventListener } from '@vueuse/core';

interface SharedHeaderProps {
  shouldShowPrintButton: boolean;
  hideBoxShadow?: boolean;
}
const props = defineProps<SharedHeaderProps>();

interface SharedHeaderEmits {
  (event: 'print-view'): void;
}
const emit = defineEmits<SharedHeaderEmits>();

useEventListener(window, 'semboPrintRequested', () => {
  emit('print-view');
});
</script>

<!-- NOTE: https://bitbucket.org/sembo-it/sembo.esg.share.web/src/main/libs/sembo-header/README.md -->
<template>
  <div
    class="header-wrapper"
    :class="{ 'without-box-shadow': props.hideBoxShadow }"
  >
    <sembo-header
      :enable-support-link="true"
      :enable-print-button="props.shouldShowPrintButton"
    />
  </div>
</template>

<style lang="scss" scoped>
.header-wrapper {
  min-height: var(--shared-header-height);
  // NOTE: temporary until inpire handles it --> https://semboteam.slack.com/archives/C0494RK1VLH/p1758715298931929

  &.without-box-shadow sembo-header * {
    box-shadow: none !important;
  }
}
</style>
